<template>
  <div class="card-container">
    <common-top-form
      :model="formModel"
      @openAddDialog="openDialog"
      @success="onSuccess"
      :submitService="submitService"
      :submitData="submitData"
      addShowPower="/tatbankprofit/add"
      buttonName="充值"
    >
      <select-organs v-model="formModel.tatSimpleId"></select-organs>
      <el-form-item label="支付类型">
        <el-select v-model="formModel.payType">
          <el-option
            v-for="item in payTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="注册账号">
        <el-input
          v-model="formModel.userPhone"
          maxlength="50"
          placeholder="请输入注册账号"
        ></el-input>
      </el-form-item>
      <el-form-item label="真实姓名">
        <el-input
          v-model="formModel.userName"
          maxlength="50"
          placeholder="请输入真实姓名"
        ></el-input>
      </el-form-item>
      <el-form-item label="订单号">
        <el-input
          v-model="formModel.orderId"
          maxlength="50"
          placeholder="请输入订单号"
        ></el-input>
      </el-form-item>
      <el-form-item label="交易类型">
        <el-select v-model="formModel.type">
          <el-option
            v-for="item in tranTypes"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="充值时间">
        <el-date-picker
          v-model="formModel.time"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>
    </common-top-form>
    <common-table :data="tableData" ref="commonTable" @handleChange="getPage">
      <el-table-column
        prop="tatName"
        label="机构名称"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="payType"
        label="支付类型"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterPayType"
      ></el-table-column>
      <el-table-column
        prop="userPhone"
        label="注册账号"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="userName"
        label="真实姓名"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="optType"
        label="操作类型"
        min-width="100"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <p :class="scope.row.optType == 1 ? 'text-green' : 'text-red'">
            {{ scope.row.optType == 1 ? "+" : "-" }}
          </p>
        </template>
      </el-table-column>
      <el-table-column
        prop="odrAmt"
        label="金额（元）"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      ></el-table-column>
      <el-table-column
        prop="rebate"
        label="转换率"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="realAmt"
        label="返利钱包到账金额（元）"
        min-width="200"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      ></el-table-column>
      <el-table-column
        prop="balAmt"
        label="余额（元）"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableNumber"
      ></el-table-column>
      <el-table-column
        prop="orderId"
        label="订单号"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="充值时间"
        min-width="160"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="type"
        label="交易类型"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
      <el-table-column
        prop="chnName"
        label="备注"
        min-width="100"
        show-overflow-tooltip
        :formatter="formatterTableData"
      ></el-table-column>
    </common-table>
    <form-dialog
      ref="formDialog"
      formDialogTitle="充值"
      :model="dialogModel"
      :dialogService="dialogService"
      :submitData="dialogData"
      :rules="dialogRules"
      class="over"
      @success="dialogSuccess"
      @close="dialogClose"
      labelWidth="110px"
    >
      <select-organs
        v-model="dialogModel.tatSimpleId"
        :selectValue="dialogModel.tatSimpleId"
        :needAll="false"
        selectWidth="100%"
      ></select-organs>
      <el-form-item label="电话号码" prop="userPhone">
        <el-input
          type="text"
          v-model="dialogModel.userPhone"
          maxlength="11"
          show-word-limit
          placeholder="请输入会员电话号码"
        ></el-input>
      </el-form-item>
      <div class="flex-row vertical-center mem-name">
        <p>会员名称：</p>
        <p v-if="memName.phoneNumber">
          {{
            memName.realName || memName.nickName || "用户" + memName.phoneNumber
          }}
        </p>
      </div>
      <el-form-item label="充值金额" prop="odrAmt">
        <el-input-number
          v-model="dialogModel.odrAmt"
          :controls="false"
          controls-position="right"
          :precision="0"
          :step="1"
          :min="0"
          style="width: 91%"
        ></el-input-number>
        <span>元</span>
      </el-form-item>
      <el-form-item label="备注">
        <el-input
          maxlength="80"
          show-word-limit
          v-model="dialogModel.remark"
          type="textarea"
          resize="none"
          rows="3"
        ></el-input>
      </el-form-item>
    </form-dialog>
  </div>
</template>

<script>
import CommonTopForm from "components/common/CommonTopForm";
import CommonTable from "components/common/CommonTable";
import SelectOrgans from "components/business/SelectOrgans";
import FormDialog from "../../dialog/FormDialog";
import FinanceService from "service/FinanceService";
import OrganService from "service/OrganService";
import Regs from "common/conf/Regs";
import TimeRange from "service/constant/TimeRange";
import { encrypt, urlEncode, objKeySort } from "common/js/common-utils";
import { loadMixin, dialogMixin, validatorsMixin } from "mixin";
import { mapGetters } from "vuex";

export default {
  name: "rebatewallet",
  data() {
    return {
      dialogRules: {
        tatSimpleId: [
          {
            required: true,
            message: "请选择机构",
          },
        ],
        userPhone: [
          {
            required: this.isPhone,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入电话号码"));
              } else if (!Regs.phone.test(value)) {
                callback(new Error("请输入正确的11位手机号码"));
              } else {
                this.getRealNameByPhone(value, (res) => {
                  if (res.respCode == "0000") {
                    this.memName = res.contents;
                    if (!this.memName.id) {
                      callback(new Error("查询不到此用户"));
                      this.memName = "";
                    } else {
                      callback();
                    }
                  } else {
                    callback(new Error("查询不到此用户"));
                    this.memName = "";
                  }
                });
              }
            },
          },
        ],
      },
      formModel: {
        tatSimpleId: "",
        payType: "",
        userPhone: "",
        userName: "",
        optType: "",
        orderId: "",
        status: "",
        type: "",
        time: TimeRange.dayRange,
      },
      tableData: [],
      dialogModel: {
        tatSimpleId: "",
        userPhone: "",
        odrAmt: "",
      },
      submitService: OrganService.rebateLogInfo,
      dialogService: OrganService.rebateLogInfoAdd,
      page: [],
      isPage: false,
      payTypes: [],
      tranTypes: [],
      all: [
        {
          dictKey: "",
          dictValue: "全部",
        },
      ],
      memName: {},
    };
  },
  mixins: [loadMixin, dialogMixin, validatorsMixin],
  components: {
    CommonTopForm,
    CommonTable,
    SelectOrgans,
    FormDialog,
  },
  created() {
    this.getTypeNames("返利支付类型", (res) => {
      this.payTypes = [...this.all, ...res];
    });
    this.getTypeNames("返利交易类型", (res) => {
      this.tranTypes = [...this.all, ...res];
    });
  },
  mounted() {
    this.page = this.$refs.commonTable.page;
    this.getList();
  },
  computed: {
    submitData() {
      if (this.formModel.time == null || this.formModel.time == "") {
        this.formModel.time = [];
      }
      const params = {
        tatSimpleId: this.formModel.tatSimpleId,
        payType: this.formModel.payType,
        userPhone: this.formModel.userPhone,
        userName: this.formModel.userName,
        optType: this.formModel.optType,
        orderId: this.formModel.orderId,
        status: this.formModel.status,
        type: this.formModel.type,
        current: this.isPage ? this.page.currentPage : 1,
        size: this.page.pageSize,
      };

      if (this.formModel.time.length != 0) {
        params.startDate = this.formModel.time[0];
        params.endDate = this.formModel.time[1];
      }
      return params;
    },
    dialogData() {
      const params = {
        odrAmt: this.dialogModel.odrAmt,
        tatSimpleId: this.dialogModel.tatSimpleId,
        userPhone: this.dialogModel.userPhone,
        remark: this.dialogModel.remark,
      };

      return params;
    },
    ...mapGetters(["serverType", "tatId", "userId"]),
  },
  methods: {
    getPage() {
      this.isPage = true;
      this.getList();
    },
    getList() {
      this.doLoad(
        this.submitService,
        this.submitData,
        (res) => {
          this.doCheck(res, (res) => {
            this.onSuccess(res);
            this.isPage = false;
          });
        },
        "信息获取失败"
      );
    },
    onSuccess(data) {
      const result = data.contents;
      this.tableData = result.rows;
      this.page.currentPage = result.current;
      this.page.total = result.total;
      this.page.pageSize = result.size;
    },
    dialogSuccess(data) {
      this.showSuccess(data.contents);
      this.$refs.formDialog.closeDialog();
      this.getList();
    },
    dialogClose() {
      this.dialogModel = {
        tatSimpleId: "",
        userPhone: "",
        odrAmt: "",
      };
      this.memName = {};
    },
    openDialog() {
      this.$refs.formDialog.open();
    },
    getRealNameByPhone(val, onSuccess) {
      const params = {
        tatSimpleId: this.dialogModel.tatSimpleId,
        phone: val,
      };
      this.doLoad(
        FinanceService.getRealNameByPhone,
        params,
        (res) => {
          onSuccess && onSuccess(res);
        },
        "信息获取失败"
      );
    },
    formatterPayType(row, column, cellValue, index) {
      let value = "--";
      this.payTypes.forEach((item) => {
        if (item.dictKey == cellValue) {
          value = item.dictValue;
        }
      });
      return value;
    },
  },
};
</script>

<style scoped>
.mem-name p {
  margin-bottom: 20px;
  vertical-align: middle;
  line-height: 40px;
  color: rgba(170, 170, 170, 1);
}

.mem-name p:first-child {
  display: inline-block;
  width: 90px;
  text-align: right;
  vertical-align: middle;
  font-size: 14px;
  color: #606266;
  line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/RebateWallet.vue